function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "illus/entity/law"
}, React.createElement("path", {
  id: "path",
  d: "M10.2965 13.8571V19.1905H12.5569V13.8571H10.2965ZM14.8173 13.8571V19.1905H17.0776V13.8571H14.8173ZM8.78955 21.8571C8.78955 22.4883 9.30123 23 9.93241 23H21.9625C22.5937 23 23.1053 22.4883 23.1053 21.8571C23.1053 21.226 22.5937 20.7143 21.9625 20.7143H9.93241C9.30122 20.7143 8.78955 21.226 8.78955 21.8571ZM19.338 13.8571V19.1905H21.5984V13.8571H19.338ZM17.2003 7.66678C16.4171 7.24994 15.4778 7.24994 14.6946 7.66678L9.2943 10.5409C8.98366 10.7062 8.78955 11.0294 8.78955 11.3813C8.78955 11.9071 9.21579 12.3333 9.74158 12.3333H22.1533C22.6791 12.3333 23.1053 11.9071 23.1053 11.3813C23.1053 11.0294 22.9112 10.7062 22.6006 10.5409L17.2003 7.66678Z",
  fill: "#303030"
}));

var SvgLaw = function SvgLaw(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,";
export { SvgLaw as ReactComponent };